import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — Resets scroll position on every route change.
 *
 * React Router preserves scroll position across route transitions by default,
 * which means clicking a nav link from mid-page loads the next page already
 * scrolled down. Mounting this component inside <BrowserRouter> restores the
 * expected "new page starts at top" behaviour.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
